import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Threats = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Threats" {...props}>
    <path d="M12.5 1C14.433 1 16 2.567 16 4.5V6C16 6.27614 16.2239 6.5 16.5 6.5C16.7761 6.5 17 6.27614 17 6V5.75C17 4.23122 18.2312 3 19.75 3H22C22.5523 3 23 3.44772 23 4C23 4.55228 22.5523 5 22 5H19.75C19.3358 5 19 5.33579 19 5.75V6C19 7.38071 17.8807 8.5 16.5 8.5C15.1193 8.5 14 7.38071 14 6V4.5C14 3.67157 13.3284 3 12.5 3C11.7794 3 11.1767 3.50801 11.0322 4.18555C12.18 4.60663 13 5.70625 13 7V7.58301C15.9316 8.76991 18 11.6428 18 15C18 19.4183 14.4183 23 10 23C5.58172 23 2 19.4183 2 15C2 11.6428 4.06844 8.76991 7 7.58301V7C7 5.68783 7.84308 4.57429 9.0166 4.16699C9.18435 2.39024 10.6794 1 12.5 1ZM10 9C6.68629 9 4 11.6863 4 15C4 18.3137 6.68629 21 10 21C13.3137 21 16 18.3137 16 15C16 11.6863 13.3137 9 10 9ZM10 6C9.44772 6 9 6.44772 9 7V7.06348C9.32766 7.02261 9.66127 7 10 7C10.3387 7 10.6723 7.02261 11 7.06348V7C11 6.44772 10.5523 6 10 6Z" fill="#000" />
  </StyledIcon>
));

Threats.displayName = 'Threats';

export { Threats };
